import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';
import *  as $ from 'jquery';
import { ResultadosService } from '../resultados.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { DATOS_API } from 'app/auth/auth.datos';


///IDIOMAS
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_izzi } from 'app/idiomas/i18n/Izzi/izzi.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_resultados_izzi } from 'app/idiomas/i18n/Izzi/resultados/resultados.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { MatSnackBar } from "@angular/material/snack-bar";
const moment = require('moment');
const momentTz = require('moment-timezone');
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
  selector: 'trustindex',
  templateUrl: './trustindex.component.html',
  styleUrls: ['./trustindex.component.scss'],
  animations : fuseAnimations
})
export class TrustIndexComponent implements OnInit {
  nivelUsuario: number;
  nombreUsuario: string;
  empresasCGO2: backInter.getCorreosResuCGO2;
  empresaDeCGO2 = false;
  productosAsignados: any[]  =[];
  productosAsignadosCertificar: any[]  =[];
  AuxproductosAsignadosCertificar: any[]  =[];
  productosLegacy: any[]  =[];
  tipoSeleccionado: string;
  tipoSeleccionadoNuevoProducto: string;
  ForAllViejas:boolean=true;
  cargando = true;
  cargandoNuevos = true;
  certificarSi=false;
  idInstituto:any;
  validarIzzi:boolean=false;
  funciones: any[]= [];
  productosNuevos: any[]= [];
  menuProductosNuevosAmco: boolean=false;
  flechaAtras2:boolean=false;

sinCertificar: boolean; //si no hay productos certificar, se usa este boolean para pintar los productos resultados
conCyR: boolean; //si no hay productos certificar, se usa este boolean para pintar los productos resultados
flagResults:any[]=[];
idiomaActual:string;
offsetPipe: string;
diferenciaUtc: number;
zonasUTC = zonasUTC;
indiceZona: number;
instUtc: number;
instituto: string;
gralResultActivo:boolean;
constructor(
  private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  private wizardService: WizardService,
  private router: Router,
  private servTableau: ResultadosService,
  private translateSrv: TranslateService,
  private _fuseSidebarService: FuseSidebarService,
  private snackBar: MatSnackBar

)
{
  lang_wizard.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });

  if(localStorage.getItem('tipoIzzi')){
    lang_resultados_izzi.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.funciones= [
      {
        id      : 'CERTIFICAR',
        slug    : 'certificar',
        category: 'CGO',
        icon : 'bubble_chart',
        imagen: 'res-cert',
        tipo: '1'
      }
    ];
    lang_izzi.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.validarIzzi=true;
  }
  else{
    lang_resultados.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    this.funciones= [
      {
        id      : localStorage.getItem('instituto_id') == '18' ? 'CERTIFICAR': (localStorage.getItem('instituto_id') == '19' ? 'MEDIR_INNO' : 'CERTIFICAR'),
        slug    : 'certificar',
        category: 'CGO',
        icon : 'bubble_chart',
        imagen: 'res-cert',
        tipo: '1',
        visible:false,
      },
      {
        id      : localStorage.getItem('instituto_id') == '18' ? 'MEDIR_AMCO': (localStorage.getItem('instituto_id') == '19' ? 'MEDIR_INNO' : 'MEDIR'),
        slug    : 'medir',
        category: 'CGO',
        icon : 'bubble_chart',
        imagen: 'res-med',
        tipo: '2',
        visible:false,
      },
      {
        id      : 'PULSE',
        slug    : 'pulse-check',
        category: 'CGO',
        icon : 'bubble_chart',
        imagen: 'res-pc',
        tipo: '3',
        visible:false,
      },
      {
        id      : 'CertiAdicio',
        slug    : 'CertiAdicio',
        category: 'CGO',
        icon : 'bubble_chart',
        imagen: 'res-pc',
        tipo: '7', ///PRODUCTOS NUEVOS AMCO
        visible:false,
      },
    ];

    this.validarIzzi=true;
  }

  this.mensajeResultModal();
  this.idiomaActual = this.translateSrv.currentLang;
}

tableauVersion:any;
ngOnInit() {
  localStorage.removeItem('resultOk');
    this._fuseSidebarService.getSidebar('navbar').fold();
  this.nivelUsuario = this.servTableau.getNivel();
  this.nombreUsuario = this.wizardService.getNombreUsuario();
  this.getEmpresasCGO2();
  this.idInstituto=parseInt(localStorage.getItem('instituto_id'));
  // if(this.idInstituto == 1 || this.idInstituto == 15){
  this.tableauVersion="3.2";
  // }
  // else if(this.idInstituto == 5){
  this.tableauVersion="3.3";
  // }
  // else{
  //   console.log("Entro versión de tablue");
  this.tableauVersion="3.1";
  // }
  console.log("idInstituto:",this.idInstituto);
  console.log("tableauVersion:",this.tableauVersion);
  this.obtieneProductosV2();
  this.obtieneInstituto();
  this.resultFuncionando();
}

calculoOffsetPipe(){
  this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
  console.log("diferenciaUtc:",this.diferenciaUtc);
  let horas = this.diferenciaUtc / 60;
  if(horas < 0){
    horas = horas * -1;
    if(horas < 10){
      this.offsetPipe = "-0" + horas + "00";
    }
    else{
      this.offsetPipe = "-" + horas + "00";
    }
  }
  else{
    if(horas < 10){
      this.offsetPipe = "+0" + horas + "00";
    }
    else{
      this.offsetPipe = "+" + horas + "00";
    }
  }
  console.log("offsetPipe:",this.offsetPipe);
}

obtieneInstituto(){
  let institutoAct = this.wizardService.getInstituto();
  console.log(institutoAct);
  switch(institutoAct){
    case '1': case 'MX': this.instituto = 'MX'; this.instUtc = 1;  break;
    case '2': case 'CAyC': this.instituto = 'CAyC'; this.instUtc = 2;   break;
    case '3': case 'HK': this.instituto = 'HK'; this.instUtc = 3;break;
    case '4': case 'SGP': this.instituto = 'WLDWDE'; this.instUtc = 4;  break;
    case '5': case 'TK': this.instituto = 'TK'; this.instUtc = 5;break;
    case '6': case 'FL': this.instituto = 'WLDWDE'; this.instUtc = 6;  break;
    case '8': case 'IZZI': this.instituto = 'IZZI'; this.instUtc = 8;  break;
    case '11': case 'BR': this.instituto = 'WLDWDE'; this.instUtc = 11;  break;
    case '14': case 'GCTI': this.instituto = 'GCTI'; this.instUtc = 1;  break;
    case '15': case 'ES': this.instituto = 'WLDWDE'; this.instUtc = 15;  break;
    case '18': case 'AMCO': this.instituto = 'AMCO'; this.instUtc = 18;  break;
    case '19':  this.instituto = 'MX'; this.instUtc = 19;  break;
    case '22': case 'HK2': this.instituto = 'HK'; this.instUtc = 22; break;
    default: this.instituto = 'WLDWDE';
  }

  this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instUtc);
  this.calculoOffsetPipe();
}

getEmpresasCGO2(){
  console.log("entro a función");
  this.servTableau.getCGO2EmpresasResults().subscribe((respuesta:backInter.getCorreosResuCGO2) => {
    console.log(respuesta);
    this.empresasCGO2 = respuesta;
    if(this.empresasCGO2.correos.indexOf(this.nombreUsuario) != -1){
      this.empresaDeCGO2 = true;
    }
  })
}

Tableau(){
  let revisar = this.servTableau.getNivel();
  console.log(revisar);
  switch(revisar){
    case 2: case 3: $('#RecDatos2').submit();
    break;

    case 4: case 5: $('#RecDatos').submit();
    break;
  }
}

goBack(){
  console.log('goBack');
  this.tipoSeleccionado = null;
  this.tipoSeleccionadoNuevoProducto = null;
  this.productosAsignados = [];
  this.productosAsignadosCertificar = [];
  this.AuxproductosAsignadosCertificar=[];
  this.cargando = true;
  this.cargandoNuevos = true;
  this.ForAllViejas=true;
}

goBack1(){
  console.log('goBack1');

    this.menuProductosNuevosAmco=false;
    this.flechaAtras2=false;
    console.log('goBack');
    this.tipoSeleccionado = null;
    this.tipoSeleccionadoNuevoProducto = null;
    this.productosAsignados = [];
    this.productosAsignadosCertificar = [];
    this.AuxproductosAsignadosCertificar=[];
    this.cargando = true;
    this.cargandoNuevos = true;
    this.ForAllViejas=true;
}
goBack2(){
  console.log('goBack2');
  this.flechaAtras2=false;
  this.tipoSeleccionadoNuevoProducto = null;
  this.cargandoNuevos=true;
  this.productosAsignados = [];
  this.productosAsignadosCertificar = [];
  this.AuxproductosAsignadosCertificar=[];
}

tituloResultado:any;
tituloResultado2:any;
productosResultados:any[]=[];


obtieneProductosV2(){
  let productCer:any[]=[];
  let productCerAdicionalesGeneral:any[]=[];
  let productCerAdicionalesAMCO:any[]=[];
  let productCerAdicionalesTraDig:any[]=[];
  let productCerAdicionalesPrimEmp:any[]=[];
  let productMedir:any[]=[];
  let productPulse:any[]=[];
  this.wizardService.getProductos().subscribe( (respuesta: backInter.infoProductos) => {
    console.log('respuesta',respuesta);
    respuesta.productosCertificar.forEach(productoCer => {
      if (productoCer.idProducto==1||productoCer.idProducto==20||productoCer.idProducto==40) {
        productCer.push(productoCer);
      }
    });
    respuesta.productosCertificar.forEach(productoCerAdicionales => {
      if (productoCerAdicionales.idProducto==56 || productoCerAdicionales.idProducto==57 || productoCerAdicionales.idProducto==58) {
        productCerAdicionalesGeneral.push(productoCerAdicionales);
      }

      if (productoCerAdicionales.idProducto==56) {
        productCerAdicionalesAMCO.push(productoCerAdicionales);
      }else if (productoCerAdicionales.idProducto==57) {
        productCerAdicionalesTraDig.push(productoCerAdicionales);
      }else if (productoCerAdicionales.idProducto==58) {
        productCerAdicionalesPrimEmp.push(productoCerAdicionales);
      }
    });


    if (respuesta.productosResultados.length>0) {
      respuesta.productosResultados.forEach(resultados => {
        if(localStorage.getItem('instituto_id')!='19'){productCer.push(resultados);}
        productMedir.push(resultados);
        if(localStorage.getItem('instituto_id')!='19'){productPulse.push(resultados);}
        // productPulse.push(resultados);
      });
    }

    if (respuesta.productosResultados4all.length>0) {
      respuesta.productosResultados4all.forEach(resultados4all => {
        productCer.push(resultados4all);
        productMedir.push(resultados4all);
        productPulse.push(resultados4all);
      });
    }

    if (respuesta.productosResultados5cero.length>0) {
      respuesta.productosResultados5cero.forEach(resultados5cero => {
        productCer.push(resultados5cero);
        productMedir.push(resultados5cero);
        productPulse.push(resultados5cero);
      });
    }
    if (respuesta.productosResultadosCompletos.length>0) {
      respuesta.productosResultadosCompletos.forEach(resultadosCompletos => {
        productCer.push(resultadosCompletos);
        productMedir.push(resultadosCompletos);
        productPulse.push(resultadosCompletos);
      });
    }
    if (respuesta.productosResultadosGlobales.length>0) {
      respuesta.productosResultadosGlobales.forEach(resultadosGlobales => {
        productCer.push(resultadosGlobales);
        productMedir.push(resultadosGlobales);
        productPulse.push(resultadosGlobales);
      });
    }
    if (respuesta.productosResultadosSencillos4ALL.length>0) {
      respuesta.productosResultadosSencillos4ALL.forEach(resultados4ALL => {
        productCer.push(resultados4ALL);
        productMedir.push(resultados4ALL);
        productPulse.push(resultados4ALL);
      });
    }

    console.log('productCer',productCer);



    respuesta.productosCertificar.forEach(productoMedir => {
      if (productoMedir.idProducto==41) {
        productMedir.push(productoMedir);
      }
    });

    if (respuesta.productosMedir2.length>0) {
      respuesta.productosMedir2.forEach(productosMedir2 => {
        productMedir.push(productosMedir2);
      });
    }
    if (respuesta.productosMedir.length>0) {
      respuesta.productosMedir.forEach(productosMedir => {
        productMedir.push(productosMedir);
      });
    }



    respuesta.productosCertificar.forEach(productosPulseCheck => {
      if (productosPulseCheck.idProducto==42) {
        productPulse.push(productosPulseCheck);
      }
    });

    if (respuesta.productosPulseCheck.length>0) {
      respuesta.productosMedir2.forEach(productosPulseCheckv1 => {
        productPulse.push(productosPulseCheckv1);
      });
    }



    switch (localStorage.getItem('instituto_id')) {
      case '19':
      // this.funciones[0].visible=false;
      if (productCer.length>0) {this.funciones[0].visible=true;}
      if (productMedir.length>0) {this.funciones[1].visible=true;}
      if (productPulse.length>0) {this.funciones[2].visible=true;}
      // this.funciones[2].visible=false;
      break;
      default:
        if (productCer.length>0) {this.funciones[0].visible=true;}
        if (productMedir.length>0) {this.funciones[1].visible=true;}
        if (productPulse.length>0) {this.funciones[2].visible=true;}
        break;
    }

    if (productCerAdicionalesGeneral.length>0) {
      this.funciones[3].visible=true;
    }
    if (productCerAdicionalesAMCO.length>0) {
      let datos={
        id      : 'Amco',
        slug    : 'Amco',
        category: 'CGO',
        icon : 'bubble_chart',
        imagen: 'res-pc',
        tipo: 'amco1', ///PRODUCTOS NUEVOS AMCO
        visible:true,
      };
      this.productosNuevos.push(datos);
    }
    if (productCerAdicionalesTraDig.length>0) {
      let datos={
        id      : 'TrabDign',
        slug    : 'TrabDign',
        category: 'CGO',
        icon : 'bubble_chart',
        imagen: 'res-pc',
        tipo: 'TrabDign', ///PRODUCTOS NUEVOS AMCO
        visible:true,
      };
      this.productosNuevos.push(datos);
    }
    if (productCerAdicionalesPrimEmp.length>0) {
      let datos={
        id      : 'PrimEmp',
        slug    : 'PrimEmp',
        category: 'CGO',
        icon : 'bubble_chart',
        imagen: 'res-pc',
        tipo: 'PrimEmp', ///PRODUCTOS NUEVOS AMCO
        visible:true,
      };
      this.productosNuevos.push(datos);
    }
    console.log('this.funciones',this.funciones);



  });

}

obtieneProductosProductoAmco(tipoProducto:string){
  this.flechaAtras2=true;
  this.tipoSeleccionadoNuevoProducto = tipoProducto;
  console.log("Tipo de producto");
  console.log(this.tipoSeleccionadoNuevoProducto);
  switch(this.tipoSeleccionadoNuevoProducto){
    case "amco1":
    let tituloResult1 = 'RESULTADOS.TABPRIN.TABAMCO';
    this.translateSrv.get(tituloResult1).subscribe((res: string) => { tituloResult1 = res; });
    this.tituloResultado2=tituloResult1;

    break;
    case "TrabDign":
    let tituloResult2 = 'RESULTADOS.TABPRIN.TABTRABDIG'
    this.translateSrv.get(tituloResult2).subscribe((res: string) => { tituloResult2 = res; });
    this.tituloResultado2=tituloResult2;

    break;
    case "PrimEmp":
    let tituloResult3 = 'RESULTADOS.TABPRIN.TABPRIEMP';
    this.translateSrv.get(tituloResult3).subscribe((res: string) => { tituloResult3 = res; });
    this.tituloResultado2=tituloResult3;

    break;

  }
  console.log("Titulo "+this.tituloResultado2);
  console.log(this.servTableau);
  console.log(this.servTableau.getNivel());

  switch(this.servTableau.getNivel()){
    case 2: case 3:
    this.navigateTo('/results/trust_index/certificar','admin',null);
    break;
    case 1: case 5: case 4: case 10:
    this.wizardService.getProductos().subscribe( (respuesta: backInter.infoProductos) => {
      console.log(respuesta);

      let prods: any;
      let prodspar1: any;
      let prodsRC:any;
      let url: string;
      let nombre: string;

      switch(tipoProducto){
        case 'amco1':
if(respuesta.productosCertificar.length > 0){
          let cerv3:any[]=[];
          respuesta.productosCertificar.forEach(certiv3 => {
            if (certiv3.idProducto==56) {
              console.log("encontro ");
              cerv3.push(certiv3);
            }

          });
          prods = cerv3;
        }else if(respuesta.productosCertificar.length == 0){
          prods = respuesta.productosResultados;
          console.log('prdocutos resultados',prods);

          this.sinCertificar = true;
        }

          url = 'certificar'; nombre = 'CERTIFICARAMCO';
        break;
        case 'TrabDign':
        if(respuesta.productosCertificar.length > 0){
          let cerv3:any[]=[];
          let productosAmco:any[]=[];
          respuesta.productosCertificar.forEach(certiv3 => {
            if (certiv3.idProducto==57) {
              console.log("encontro ");
              cerv3.push(certiv3);
            }

          });
          prods = cerv3;
        }

          url = 'certificar'; nombre = 'CERTIFICARTRABADIG';
        break;
        case 'PrimEmp':
        if(respuesta.productosCertificar.length > 0){
          let cerv3:any[]=[];
          let productosAmco:any[]=[];
          respuesta.productosCertificar.forEach(certiv3 => {
            if (certiv3.idProducto==58) {
              console.log("encontro ");
              cerv3.push(certiv3);
            }

          });
          prods = cerv3;
        }

          url = 'certificar'; nombre = 'CERTIFICARADICPRIEMPL';
      }
      prods = this.ordenaDescendente(prods, tipoProducto);
      if(this.conCyR==true){
        prodsRC = this.ordenaDescendenteRYC(prodsRC, tipoProducto);
      }
      // console.log(prods);
      this.colocaProductos(nombre,url,prods,prodsRC);
    });
    break;
  }
  this.ForAllViejas=false;
}

obtieneProductos(tipoProducto:string){
  this.tipoSeleccionado= tipoProducto;
  console.log("Tipo de producto");
  console.log(this.tipoSeleccionado);
  switch(this.tipoSeleccionado){
    case "1":
    let tituloResult1 = localStorage.getItem('instituto_id') == '18' ? 'RESULTADOS.TABPRIN.TABPRO' :(localStorage.getItem('instituto_id') == '19' ? 'RESULTADOS.TABPRIN.TABINNO' : 'RESULTADOS.TABPRIN.TABPRO');
    //this.translateSrv.get(tituloResult1).subscribe((res: string) => { tituloResult1 = res; });
    this.tituloResultado=tituloResult1;
    this.menuProductosNuevosAmco=false;
    break;
    case "2":
    let tituloResult2 = localStorage.getItem('instituto_id') == '18' ? 'RESULTADOS.TABPRIN.TABICI' :(localStorage.getItem('instituto_id') == '19' ? 'RESULTADOS.TABPRIN.TABINNO' : 'RESULTADOS.TABPRIN.TABCER');
    //this.translateSrv.get(tituloResult2).subscribe((res: string) => { tituloResult2 = res; });
    this.tituloResultado=tituloResult2;
    this.menuProductosNuevosAmco=false;
    break;
    case "3":
    let tituloResult3 = 'RESULTADOS.TABPRIN.TABPULSE';
    //this.translateSrv.get(tituloResult3).subscribe((res: string) => { tituloResult3 = res; });
    this.tituloResultado=tituloResult3;
    this.menuProductosNuevosAmco=false;
    break;
    case "7":
    // let tituloResult7 = 'RESULTADOS.TABPRIN.TABPULSE';
    let tituloResult7 = 'CERTIFICACIONES ADICIONALES ';
    //this.translateSrv.get(tituloResult3).subscribe((res: string) => { tituloResult3 = res; });
    this.tituloResultado=tituloResult7;
    this.menuProductosNuevosAmco=true;
    break;
  }
  console.log("Titulo "+this.tituloResultado);
  console.log(this.servTableau);
  console.log(this.servTableau.getNivel());

  switch(this.servTableau.getNivel()){
    case 2: case 3:
    this.navigateTo('/results/trust_index/certificar','admin',null);
    break;
    case 1: case 5: case 4: case 10:
    this.wizardService.getProductos().subscribe( (respuesta: backInter.infoProductos) => {
      console.log(respuesta);

      let prods: any;
      let prodspar1: any;
      let prodsRC:any;
      let url: string;
      let nombre: string;
      let tokenEncuesta: string;
      let idSurveyConfiguration: string;

      switch(tipoProducto){
        case '1':
        if(respuesta.productosCertificar.length > 0 && respuesta.productosResultados.length > 0){
          prods = respuesta.productosCertificar;
          prodsRC = respuesta.productosResultados;
          this.productosResultados=prodsRC;
          // console.log(prods);
          // console.log(prodsRC);
          if (localStorage.getItem('instituto_id')!='19') {
            prodsRC.forEach((prodResu,i) => {
              prods.forEach(prodCert => {
                // console.log("prodRC:",prodResu," prodCer:",prodCert);
                console.log("prodRC-fecha:",prodResu.fecha," prodCer-fecha:",prodCert.fechaCertificar);

                if(prodResu.fecha === prodCert.fechaCertificar){
                  // prods.splice(i,1);
                  prodsRC.splice(i,1,{
                    activo: true,
                    fecha: prodCert.fechaCertificar,
                    surveyToken: prodCert.tokenConfig,
                    version: prodResu.version,
                    _id: prodCert.idCertificar
                  });
                }else{
                    }
                  });
                });
                this.conCyR=true;
                console.log('prodsRC',prodsRC);

          }
        }
        else if(respuesta.productosCertificar.length > 0){
          let cerv3:any[]=[];
          respuesta.productosCertificar.forEach(certiv3 => {
            if (certiv3.idProducto==1 || certiv3.idProducto==20 || certiv3.idProducto==40 || certiv3.idProducto == 75) {
              console.log("encontro ");
              cerv3.push(certiv3);
            }

          });
          prods = cerv3;
        }
        else if(respuesta.productosCertificar.length == 0){
          prods = respuesta.productosResultados;
          console.log('prdocutos resultados',prods);

          this.sinCertificar = true;
        }
        else{
          if(respuesta.productosMedir.length == 0 && respuesta.productosMedir2.length == 0 && respuesta.productosPulseCheck.length == 0 && respuesta.productosFocusArea.length == 0){
            prods = respuesta.productosResultados;
            this.sinCertificar = true;
          }
          else prods = [];
        }
        if(localStorage.getItem('tipoIzzi')){
          url = 'certificar'; nombre = 'IZZI';
        }
        else{

          url = localStorage.getItem('instituto_id') == '19' ? 'innotion' : 'certificar';
          nombre = localStorage.getItem('instituto_id') == '19' ? 'CERTIFICAR' : 'CERTIFICAR';
          // url = 'certificar'; nombre = 'CERTIFICAR';
        }
        break;
        case '7':
        if(respuesta.productosCertificar.length > 0){
          let cerv3:any[]=[];
          let productosAmco:any[]=[];
          respuesta.productosCertificar.forEach(certiv3 => {
            if (certiv3.idProducto==56 || certiv3.idProducto==57 || certiv3.idProducto==58) {
              console.log("encontro ");
              cerv3.push(certiv3);
            }

          });
          prods = cerv3;
        }

          url = 'certificar'; nombre = 'CERTIFICARADIC';
        break;
        case '2':
        if (localStorage.getItem('instituto_id')=='19') {
          console.log("entro medir");

          if(respuesta.productosCertificar.length > 0 && respuesta.productosResultados.length > 0){
            prods = respuesta.productosCertificar;
            prodsRC = respuesta.productosResultados;
            this.productosResultados=prodsRC;
            // console.log(prods);
            console.log(prodsRC);
            prodsRC.forEach((prodResu,i) => {
              prods.forEach(prodCert => {
                // console.log("prodRC:",prodResu," prodCer:",prodCert);
                console.log("prodRC-fecha:",prodResu.fecha," prodCer-fecha:",prodCert.fechaCertificar);

                if(prodResu.fecha === prodCert.fechaCertificar){
                  // prods.splice(i,1);
                  prodsRC.splice(i,1,{
                    activo: true,
                    fecha: prodCert.fechaCertificar,
                    surveyToken: prodCert.tokenConfig,
                    version: prodResu.version,
                    _id: prodCert.idCertificar
                  });
                }else{
                  // if(prodResu.fecha === prodCert.fechaCertificar){
                  // console.log('ya se encuentra');
                  // }else{
                  //   console.log('no se encontro la primera vez',prodCert);
                  //   prodsRC.push(prodCert);
                  // }
                }
              });
            });
            this.conCyR=true;
            console.log('prodsRC',prodsRC);
          }
          else if(respuesta.productosCertificar.length > 0){
            let cerv3:any[]=[];
            respuesta.productosCertificar.forEach(certiv3 => {
              if (certiv3.idProducto==41) {
                console.log("encontro ");
                cerv3.push(certiv3);
              }

            });
            prods = cerv3;
          }
          else if(respuesta.productosCertificar.length == 0){
            prods = respuesta.productosResultados;
            console.log('prdocutos resultados',prods);

            this.sinCertificar = true;
          }
          else{
            if(respuesta.productosMedir.length == 0 && respuesta.productosMedir2.length == 0 && respuesta.productosPulseCheck.length == 0 && respuesta.productosFocusArea.length == 0){
              prods = respuesta.productosResultados;
              this.sinCertificar = true;
            }
            else prods = [];
          }
            console.log("prods#############",prods);

        }else{
          let medv3:any[]=[];
          respuesta.productosCertificar.forEach(medirv3 => {
            if (medirv3.idProducto==41) {
              console.log("encontro ");
              medv3.push(medirv3);
            }

          });
          let prodMed1: any = respuesta.productosMedir;
          let prodMed2: any = respuesta.productosMedir2;

          prodspar1 = prodMed1.concat(prodMed2);
          prods = prodspar1.concat(medv3);
          console.log("e0sdsa",prods);

        }
        // url = 'medir';
        url = localStorage.getItem('instituto_id') == '19' ? 'innotion' : 'medir';
        nombre = localStorage.getItem('instituto_id') == '18' ? 'MEDIR_M8' :(localStorage.getItem('instituto_id') == '19' ? 'MEDIR_M9' : 'MEDIR');

        break;
        case '3':
        let pulv3:any[]=[];
        respuesta.productosCertificar.forEach(pulsev3 => {
          if (pulsev3.idProducto==42) {
            console.log("encontro ");

            pulv3.push(pulsev3);
          }

        });
        prods = respuesta.productosPulseCheck.concat(pulv3);
        console.log("e0sdsa",prods); url = 'pulse-check'; nombre = 'PULSE'; break;
        case '4': prods = respuesta.productosFocusArea; url = 'focus'; nombre = 'FOCUS'; break;
      }
      prods = this.ordenaDescendente(prods, tipoProducto);
      if(this.conCyR==true){
        prodsRC = this.ordenaDescendenteRYC(prodsRC, tipoProducto);
      }
      // console.log(prods);
      this.colocaProductos(nombre,url,prods,prodsRC);
    });
    break;
  }
  this.ForAllViejas=false;
}

ordenaDescendente(datos:any, tipo:string){
  switch(tipo){
    case '1':
    if(!this.sinCertificar){
      datos.sort( (a,b) => { if(a.fechaCertificar < b.fechaCertificar){ return 1; } else{ return -1; } });
    }
    else{
      datos.sort( (a,b) => { if(a.fecha < b.fecha){ return 1; } else{ return -1; } });
    }
    break;
    case '2': datos.sort( (a,b) => { if(a.fechaMedir < b.fechaMedir){ return 1; } else{ return -1; } }); break;
    case '3': datos.sort( (a,b) => { if(a.fechaPulseCheck < b.fechaPulseCheck){ return 1; } else{ return -1; } }); break;
    case '4': datos.sort( (a,b) => { if(a.fechaFocus < b.fechaFocus){ return 1; } else{ return -1; } }); break;
    case '7': case '8': case '9':
    if(!this.sinCertificar){
      datos.sort( (a,b) => { if(a.fechaCertificar < b.fechaCertificar){ return 1; } else{ return -1; } });
    }
    else{
      datos.sort( (a,b) => { if(a.fecha < b.fecha){ return 1; } else{ return -1; } });
    }
  }
  return datos;
}

ordenaDescendenteRYC(prodsRC:any, tipo:string){
  switch(tipo){
    case '1':
    prodsRC.sort( (a,b) => { if(a.fecha < b.fecha){ return 1; } else{ return -1; } });
    break;
  }
  return prodsRC;
}


// colocaProductos(producto:string, url:string, datos:any, prodsRC:any){
//   // console.log(datos);
//   console.log("producto:",producto,  "url:",url,  "datos:",datos,  "prodsRC:",prodsRC);
//   console.log("conCyR:",this.conCyR);
//
//   //agrega un producto de tipo resultados heredados
//   this.productosLegacy = [];
//   if(producto == 'CERTIFICAR' || producto == 'IZZI'){
//     if(this.empresaDeCGO2){
//       this.productosLegacy.push(
//         {
//           category: 'CGO',
//           length  : 30,
//           title   : 'WIZARD.'+producto+'.TITULO',
//           date : 2000,
//           url : url,
//           productoID : 123,
//           start : 'WIZARD.LANDING.ENTRAR',
//           completo: 2,
//           tagStatus: 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED'
//         }
//       );
//     }
//   }
//   console.log("Colocar productos");
//
//   if(!this.conCyR){
//
//     datos.forEach( (elem) => {
//       console.log(elem);
//       let fecha:number;
//       let idProducto:string;
//       let completo: number;
//       let tagStatus: string;
//       let tableauVersion: string;
//       let activo = true;
//       switch(producto){
//         case 'CERTIFICAR': case 'IZZI':
//           if(!this.sinCertificar){
//             fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
//             completo = elem.completoCertificar; activo = elem.activo;
//           }
//           else{
//             fecha = elem.fecha; idProducto = elem._id;
//             completo = 2; tableauVersion = elem.version; activo = elem.activo;
//           }
//
//         break;
//         case 'MEDIR':
//         if(elem.idMedir){
//           fecha = elem.fechaMedir; idProducto = elem.idMedir;
//           completo = elem.completoMedir;
//         }
//         else{
//           fecha = elem.fechaProducto; idProducto = elem.idProducto;
//           completo = elem.completo;
//         }
//         break;
//         case 'PULSE':
//         fecha = elem.fechaPulseCheck; idProducto = elem.idPulseCheck;
//         completo = elem.completoPulseCheck;
//         break;
//         case 'FOCUS':
//         fecha = elem.fechaFocus; idProducto = elem.idFocusArea;
//         completo = elem.completoFocusArea;
//         break;
//       }
//       switch(completo){
//         // case 1: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.CURRENT'; break;
//         default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED';
//       }
//       this.productosAsignados.push(
//         {
//           category: 'CGO',
//           length  : 30,
//           title   : 'WIZARD.'+producto+'.TITULO',
//           date : fecha,
//           url : url,
//           productoID : idProducto,
//           start : 'WIZARD.LANDING.ENTRAR',
//           completo,
//           tagStatus,
//           tableauVersion,
//           activo,
//           idProducto: elem.idProducto,
//         }
//       );
//
//       this.productosAsignadosCertificar.push(
//         {
//           category: 'CGO',
//           length  : 30,
//           title   : 'WIZARD.'+producto+'.TITULO',
//           date : fecha,
//           url : url,
//           productoID : idProducto,
//           start : 'WIZARD.LANDING.ENTRAR',
//           completo,
//           tagStatus,
//           tableauVersion,
//           activo
//         }
//       );
//     });
//     console.log("este viste ya jalo yeah:::: ",this.productosAsignados);
//     console.log("este viste ya jalo yeah:::: ",this.productosAsignadosCertificar);
//
//
//
//   }
//   else{
//     console.log("DATOS:",datos);
//     console.log("prodsRC:",prodsRC);
//
//     prodsRC.forEach( (elem) => {
//       console.log(elem);
//       let fecha:number;
//       let idProducto:string;
//       let completo: number;
//       let tagStatus: string;
//       let tableauVersion: string;
//       let activo: boolean;
//       let idProductoForall: string;
//       switch(producto){
//         case 'CERTIFICAR': case 'IZZI':
//         fecha = elem.fecha; idProducto = elem._id;
//         completo = 2; tableauVersion = elem.version; activo = elem.activo;
//
//         var BreakException = {};
//         try {
//           datos.forEach((prodCert:any) => {
//             if(prodCert.fechaCertificar == elem.fecha){
//               idProductoForall = prodCert.idCertificar;
//               throw BreakException;
//             }
//           });
//         } catch (e) {
//           if (e !== BreakException) throw e;
//         };
//         break;
//       }
//       switch(completo){
//         // case 1: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.CURRENT'; break;
//         default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED';
//       }
//       this.productosAsignados.push(
//         {
//           category: 'CGO',
//           length  : 30,
//           title   : 'WIZARD.'+producto+'.TITULO',
//           date : fecha,
//           url : url,
//           productoID : idProducto,
//           start : 'WIZARD.LANDING.ENTRAR',
//           completo,
//           tagStatus,
//           tableauVersion,
//           activo,
//           idProductoForall
//         }
//       );
//     });
//     datos.forEach( (elem) => {
//       console.log(elem);
//       let fecha:number;
//       let idProducto:string;
//       let completo: number;
//       let tagStatus: string;
//       let tableauVersion: string;
//       let activo: boolean;
//       let idProductoForall: string;
//       switch(producto){
//         case 'CERTIFICAR': case 'IZZI':
//         fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
//         completo = 2; tableauVersion = elem.tokenConfig; activo = elem.activo;
//
//         var BreakException = {};
//         try {
//           datos.forEach((prodCert:any) => {
//             if(prodCert.fechaCertificar == elem.fechaCertificar){
//               idProductoForall = prodCert.idCertificar;
//               throw BreakException;
//             }
//           });
//         } catch (e) {
//           if (e !== BreakException) throw e;
//         };
//         break;
//       }
//       switch(completo){
//         // case 1: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.CURRENT'; break;
//         default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED';
//       }
//       this.productosAsignadosCertificar.push(
//         {
//           category: 'CGO',
//           length  : 30,
//           title   : 'WIZARD.'+producto+'.TITULO',
//           date : fecha,
//           url : url,
//           productoID : idProducto,
//           start : 'WIZARD.LANDING.ENTRAR',
//           completo,
//           tagStatus,
//           // tableauVersion: this.tableauVersion,
//           activo,
//           idProductoForall
//         }
//       );
//     });
//     console.log("asignados solamente certificar con resultados.:::::::::::::::::: ",this.productosAsignadosCertificar);
//     if(this.productosAsignadosCertificar.length > 0){
//       this.productosAsignados=this.productosAsignadosCertificar;
//       if(this.productosResultados.length > 0 && this.productosAsignados.length < this.productosResultados.length){
//         console.log("Tiene resultados extras");
//         for(let inicio = 0; inicio < this.productosResultados.length; inicio++){
//           this.AuxproductosAsignadosCertificar.push(
//             {
//               category: 'CGO',
//               length  : 30,
//               title   : 'WIZARD.'+producto+'.TITULO',
//               date : this.productosResultados[inicio].fecha,
//               url : url,
//               productoID :this.productosResultados[inicio]._id,
//               start : 'WIZARD.LANDING.ENTRAR',
//               completo: 2,
//               tagStatus: "WIZARD.LANDING.PRODUCTO.CERTIFICAR.RESULTS.FINISHED",
//               // tableauVersion: this.tableauVersion,
//               activo:this.productosResultados[inicio].activo,
//               idProductoForall: this.productosResultados[inicio]._id
//             }
//           );
//
//         }// FIN for
//         //console.log(this.AuxproductosAsignadosCertificar);
//         this.productosAsignados=this.AuxproductosAsignadosCertificar;
//       }
//     }
//
//   }
//   this.cargando = false;
//   console.log("asignados.",this.productosAsignados);
//
// }

colocaProductos(producto:string, url:string, datos:any, prodsRC:any){
  // console.log(datos);
  console.log("producto:",producto);
  console.log("url:",url);
  console.log("datos:",datos);
  console.log("prodsRC:",prodsRC);
  console.log("conCyR:",this.conCyR);

  //agrega un producto de tipo resultados heredados
  this.productosLegacy = [];
  if(producto == 'CERTIFICAR' || producto == 'IZZI'){
    console.log('this.empresaDeCGO2',this.empresaDeCGO2);
    if(this.empresaDeCGO2){
      this.productosLegacy.push(
        {
          category: 'CGO',
          length  : 30,
          title   : 'WIZARD.'+producto+'.TITULO',
          date : 2000,
          url : url,
          productoID : 123,
          start : 'WIZARD.LANDING.ENTRAR',
          completo: 2,
          tagStatus: 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED'
        }
      );
    }
  }
  console.log("Colocar productos");

  if(!this.conCyR){

    datos.forEach( (elem) => {
      console.log(elem);
      let fecha:number;
      let idProducto:string;
      let versionProducto:number;
      let numeroPulse:number;
      let completo: number;
      let tagStatus: string;
      let tableauVersion: string;
      let activo = true;
      let tokenEncuesta: string;
      let idSurveyConfiguration: string;
      let fechaCierreEncuesta: string;
      switch(producto){
        case 'CERTIFICAR': case 'IZZI':
        console.log(this.sinCertificar);

        if(!this.sinCertificar){
          if (elem.idProducto==1 || elem.idProducto==20 || elem.idProducto==40 || elem.idProducto == 75) {
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar; activo = elem.activo; tokenEncuesta=elem.tokenConfig; idSurveyConfiguration=elem.idSurvey;
            if (elem.fechaCierre) {
              fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
            }else{
              fechaCierreEncuesta="";
            }

          }

        }else{
          if (elem.idProducto==1 || elem.idProducto==20 || elem.idProducto==40) {
        console.log('ENTRO ESTE PRODUCTO');
        console.log('elem',elem);

          fecha = elem.fecha; idProducto = elem._id;
          completo = 2; tableauVersion = elem.version; activo = elem.activo; tokenEncuesta=elem.tokenConfig;idSurveyConfiguration=elem.idSurvey;
          if (elem.fechaCierre) {
            fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
          }else{
            fechaCierreEncuesta="";
          }

        }
        }


          this.productosAsignados.push(
            {
              category: 'CGO',
              length  : 30,
              title   : localStorage.getItem('instituto_id') == '19' ? 'WIZARD.MEDIR_M9.TITULO' : (elem.idProducto != 75 ? 'WIZARD.CERTIFICAR.TITULO' : 'WIZARD.CERTIFICAR.TITULO_GPTWGCTI'),
              date : fecha,
              url : url,
              productoID : idProducto,
              start : 'WIZARD.LANDING.ENTRAR',
              completo,
              tagStatus,
              tableauVersion,
              activo,
              idProducto: elem.idProducto,
              tokenEncuesta: tokenEncuesta,
              idSurveyConfig:idSurveyConfiguration,
              fechaCierre:fechaCierreEncuesta,

            }
          );

          this.productosAsignadosCertificar.push(
            {
              category: 'CGO',
              length  : 30,
              title   : localStorage.getItem('instituto_id') == '19' ? 'WIZARD.MEDIR_M9.TITULO' : (elem.idProducto != 75 ? 'WIZARD.CERTIFICAR.TITULO' : 'WIZARD.CERTIFICAR.TITULO_GPTWGCTI'),
              date : fecha,
              url : url,
              productoID : idProducto,
              start : 'WIZARD.LANDING.ENTRAR',
              completo,
              tagStatus,
              tableauVersion,
              activo,
              idProducto:elem.idProducto,
              tokenEncuesta:tokenEncuesta,
              idSurveyConfig:idSurveyConfiguration,
              fechaCierre:fechaCierreEncuesta,

            }
          );
          // }
        break;
        case 'CERTIFICARAMCO':
        console.log(this.sinCertificar);

        if(!this.sinCertificar){
          if (elem.idProducto==56) {
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar; activo = elem.activo;
            tokenEncuesta=elem.tokenConfig; idSurveyConfiguration=elem.idSurvey;
            if (elem.fechaCierre) {
              fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
            }else{
              fechaCierreEncuesta="";
            }
          }

        }else{
          if (elem.idProducto==56) {
        console.log('ENTRO ESTE PRODUCTO');
        console.log('elem',elem);

          fecha = elem.fecha; idProducto = elem._id;
          completo = 2; tableauVersion = elem.version; activo = elem.activo;
          tokenEncuesta=elem.tokenConfig; idSurveyConfiguration=elem.idSurvey;
          if (elem.fechaCierre) {
            fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
          }else{
            fechaCierreEncuesta="";
          }
        }
        }
          this.productosAsignados.push(
            {
              category: 'CGO',
              length  : 30,
              title   : 'WIZARD.'+producto+'.TITULO',
              date : fecha,
              url : url,
              productoID : idProducto,
              start : 'WIZARD.LANDING.ENTRAR',
              completo,
              tagStatus,
              tableauVersion,
              activo,
              idProducto: elem.idProducto,
              tokenEncuesta: tokenEncuesta,
              idSurveyConfig:idSurveyConfiguration,
              fechaCierre:fechaCierreEncuesta,

            }
          );

          this.productosAsignadosCertificar.push(
            {
              category: 'CGO',
              length  : 30,
              title   : 'WIZARD.'+producto+'.TITULO',
              date : fecha,
              url : url,
              productoID : idProducto,
              start : 'WIZARD.LANDING.ENTRAR',
              completo,
              tagStatus,
              tableauVersion,
              activo,
              idProducto:elem.idProducto,
              tokenEncuesta: tokenEncuesta,
              idSurveyConfig:idSurveyConfiguration,
              fechaCierre:fechaCierreEncuesta,
            }
          );
          // }
        break;
        case 'CERTIFICARTRABADIG':
        console.log(this.sinCertificar);

        if(!this.sinCertificar){
          if (elem.idProducto==57) {
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar; activo = elem.activo;tokenEncuesta=elem.tokenConfig; idSurveyConfiguration=elem.idSurvey;
            if (elem.fechaCierre) {
              fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
            }else{
              fechaCierreEncuesta="";
            }
          }

        }else{
          if (elem.idProducto==57) {
        console.log('ENTRO ESTE PRODUCTO');
        console.log('elem',elem);

          fecha = elem.fecha; idProducto = elem._id;
          completo = 2; tableauVersion = elem.version; activo = elem.activo;
          tokenEncuesta=elem.tokenConfig;idSurveyConfiguration=elem.idSurvey;
          if (elem.fechaCierre) {
            fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
          }else{
            fechaCierreEncuesta="";
          }
        }
        }
          this.productosAsignados.push(
            {
              category: 'CGO',
              length  : 30,
              title   : 'WIZARD.'+producto+'.TITULO',
              date : fecha,
              url : url,
              productoID : idProducto,
              start : 'WIZARD.LANDING.ENTRAR',
              completo,
              tagStatus,
              tableauVersion,
              activo,
              idProducto: elem.idProducto,
              tokenEncuesta: tokenEncuesta,
              idSurveyConfig:idSurveyConfiguration,
              fechaCierre:fechaCierreEncuesta,

            }
          );

          this.productosAsignadosCertificar.push(
            {
              category: 'CGO',
              length  : 30,
              title   : 'WIZARD.'+producto+'.TITULO',
              date : fecha,
              url : url,
              productoID : idProducto,
              start : 'WIZARD.LANDING.ENTRAR',
              completo,
              tagStatus,
              tableauVersion,
              activo,
              idProducto:elem.idProducto,
              tokenEncuesta:fechaCierreEncuesta,
              idSurveyConfig:idSurveyConfiguration,
            }
          );
          // }
        break;
        case 'CERTIFICARADICPRIEMPL':
        console.log(this.sinCertificar);

        if(!this.sinCertificar){
          if (elem.idProducto==58) {
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar; activo = elem.activo;
            tokenEncuesta=elem.tokenConfig;idSurveyConfiguration=elem.idSurvey;
            if (elem.fechaCierre) {
              fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
            }else{
              fechaCierreEncuesta="";
            }
          }

        }else{
          if (elem.idProducto==58) {
        console.log('ENTRO ESTE PRODUCTO');
        console.log('elem',elem);

          fecha = elem.fecha; idProducto = elem._id;
          completo = 2; tableauVersion = elem.version; activo = elem.activo;
          tokenEncuesta=elem.tokenConfig;idSurveyConfiguration=elem.idSurvey;
          if (elem.fechaCierre) {
            fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
          }else{
            fechaCierreEncuesta="";
          }
        }
        }
          this.productosAsignados.push(
            {
              category: 'CGO',
              length  : 30,
              title   : 'WIZARD.'+producto+'.TITULO',
              date : fecha,
              url : url,
              productoID : idProducto,
              start : 'WIZARD.LANDING.ENTRAR',
              completo,
              tagStatus,
              tableauVersion,
              activo,
              idProducto: elem.idProducto,
              tokenEncuesta: tokenEncuesta,
              idSurveyConfig:idSurveyConfiguration,
              fechaCierre:fechaCierreEncuesta,

            }
          );

          this.productosAsignadosCertificar.push(
            {
              category: 'CGO',
              length  : 30,
              title   : 'WIZARD.'+producto+'.TITULO',
              date : fecha,
              url : url,
              productoID : idProducto,
              start : 'WIZARD.LANDING.ENTRAR',
              completo,
              tagStatus,
              tableauVersion,
              activo,
              idProducto:elem.idProducto,
              tokenEncuesta:fechaCierreEncuesta,
              idSurveyConfig:idSurveyConfiguration,
            }
          );
          // }
        break;
        case 'MEDIR': case 'MEDIR_M8':
        if (!elem.idProducto) {
          elem.idProducto="2";
        }
        if (elem.idProducto==41) {
          if(elem.idCertificar){
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar;
            tokenEncuesta=elem.tokenConfig;idSurveyConfiguration=elem.idSurvey;
            if (elem.fechaCierre) {
              fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
            }else{
              fechaCierreEncuesta="";
            }
          }
          else{
            fecha = elem.fechaProducto; idProducto = elem.idProducto;
            completo = elem.completo;
            tokenEncuesta=elem.tokenConfig;idSurveyConfiguration=elem.idSurvey;
            if (elem.fechaCierre) {
              fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
            }else{
              fechaCierreEncuesta="";
            }
          }

        }else{
          if(elem.idMedir){
            fecha = elem.fechaMedir; idProducto = elem.idMedir;
            completo = elem.completoMedir;
            tokenEncuesta=elem.tokenConfig;idSurveyConfiguration=elem.idSurvey;
            if (elem.fechaCierre) {
              fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
            }else{
              fechaCierreEncuesta="";
            }
          }
          else{
            fecha = elem.fechaProducto; idProducto = elem.idProducto;
            completo = elem.completo;
            tokenEncuesta=elem.tokenConfig;idSurveyConfiguration=elem.idSurvey;
            if (elem.fechaCierre) {
              fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
            }else{
              fechaCierreEncuesta="";
            }
          }

        }
        this.productosAsignados.push(
          {
            category: 'CGO',
            length  : 30,
            title   : 'WIZARD.'+producto+'.TITULO',
            date : fecha,
            url : url,
            productoID : idProducto,
            start : 'WIZARD.LANDING.ENTRAR',
            completo,
            tagStatus,
            tableauVersion,
            activo,
            idProducto: elem.idProducto,
            tokenEncuesta: tokenEncuesta,
            idSurveyConfig:idSurveyConfiguration,
            fechaCierre:fechaCierreEncuesta,
          }
        );
        break;
        case 'MEDIR_M9':
        console.log(this.sinCertificar);

        if(!this.sinCertificar){
          if (elem.idProducto==41) {
            fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
            completo = elem.completoCertificar; activo = elem.activo; tokenEncuesta=elem.tokenConfig; idSurveyConfiguration=elem.idSurvey;
            if (elem.fechaCierre) {
              fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
            }else{
              fechaCierreEncuesta="";
            }

          }

        }else{
        console.log('ENTRO ESTE PRODUCTO');
        console.log('elem',elem);

          fecha = elem.fecha; idProducto = elem._id;
          completo = 2; tableauVersion = elem.version; activo = elem.activo; tokenEncuesta=elem.tokenConfig; idSurveyConfiguration=elem.idSurvey;
          if (elem.fechaCierre) {
            fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
          }else{
            fechaCierreEncuesta="";
          }

        }

        this.productosAsignados.push(
          {
            category: 'CGO',
            length  : 30,
            title   : 'WIZARD.'+producto+'.TITULO',
            date : fecha,
            url : url,
            productoID : idProducto,
            start : 'WIZARD.LANDING.ENTRAR',
            completo,
            tagStatus,
            tableauVersion,
            activo,
            idProducto: elem.idProducto,
            tokenEncuesta: tokenEncuesta,
            idSurveyConfig:idSurveyConfiguration,
            fechaCierre:fechaCierreEncuesta,

          }
        );

        this.productosAsignadosCertificar.push(
          {
            category: 'CGO',
            length  : 30,
            title   : 'WIZARD.'+producto+'.TITULO',
            date : fecha,
            url : url,
            productoID : idProducto,
            start : 'WIZARD.LANDING.ENTRAR',
            completo,
            tagStatus,
            tableauVersion,
            activo,
            idProducto:elem.idProducto,
            tokenEncuesta:fechaCierreEncuesta,
            idSurveyConfig:idSurveyConfiguration,
          }
        );
        break;
        case 'PULSE':
        if (elem.idProducto==42) {
          fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
          completo = elem.completoCertificar;numeroPulse=elem.numPulse;
          tokenEncuesta=elem.tokenConfig; idSurveyConfiguration=elem.idSurvey;
          if (elem.fechaCierre) {
            fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
          }else{
            fechaCierreEncuesta="";
          }
      }
      else{
        fecha = elem.fechaPulseCheck; idProducto = elem.idPulseCheck;
        completo = elem.completoPulseCheck;numeroPulse=elem.numero;
        tokenEncuesta=elem.tokenConfig; idSurveyConfiguration=elem.idSurvey;
        if (elem.fechaCierre) {
          fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
        }else{
          fechaCierreEncuesta="";
        }
      }
        this.productosAsignados.push(
          {
            category: 'CGO',
            length  : 30,
            title   : 'WIZARD.'+producto+'.TITULO',
            date : fecha,
            url : url,
            productoID : idProducto,
            start : 'WIZARD.LANDING.ENTRAR',
            completo,
            tagStatus,
            tableauVersion,
            activo,
            idProducto: elem.idProducto,
            numeroPul:numeroPulse,
            tokenEncuesta:fechaCierreEncuesta,
            idSurveyConfig:idSurveyConfiguration,
          }
        );
        break;
        case 'FOCUS':
        fecha = elem.fechaFocus; idProducto = elem.idFocusArea;
        completo = elem.completoFocusArea;
        tokenEncuesta=elem.tokenConfig; idSurveyConfiguration=elem.idSurvey;
        if (elem.fechaCierre) {
          fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
        }else{
          fechaCierreEncuesta="";
        }
        this.productosAsignados.push(
          {
            category: 'CGO',
            length  : 30,
            title   : 'WIZARD.'+producto+'.TITULO',
            date : fecha,
            url : url,
            productoID : idProducto,
            start : 'WIZARD.LANDING.ENTRAR',
            completo,
            tagStatus,
            tableauVersion,
            activo,
            idProducto: elem.idProducto,
            tokenEncuesta: tokenEncuesta,
            idSurveyConfig:idSurveyConfiguration,
            fechaCierre:fechaCierreEncuesta,
          }
        );
        break;
      }
      switch(completo){
        // case 1: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.CURRENT'; break;
        default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED';
      }
    });
    console.log("productosAsignados:::: ",this.productosAsignados);
    console.log("productosAsignadosCertificar:::: ",this.productosAsignadosCertificar);
  }
  else{
    console.log("DATOS:",datos);
    console.log("prodsRC:",prodsRC);
    prodsRC.forEach( (elem) => {
      console.log(elem);
      let fecha:number;
      let idProducto:string;
      let completo: number;
      let tagStatus: string;
      let tableauVersion: string;
      let activo: boolean;
      let idProductoForall: string;
      let tokenEncuesta: string;
      let idSurveyConfiguration: string;
      let fechaCierreEncuesta: string;
      switch(producto){
        case 'CERTIFICAR': case 'IZZI':
        fecha = elem.fecha; idProducto = elem._id;
        completo = 2; tableauVersion = elem.version; activo = elem.activo;
        tokenEncuesta=elem.tokenConfig;
        idSurveyConfiguration=elem.idSurvey;
        if (elem.fechaCierre) {
          fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
        }else{
          fechaCierreEncuesta="";
        }

        var BreakException = {};
        try {
          datos.forEach((prodCert:any) => {
            if(prodCert.fechaCertificar == elem.fecha){
              idProductoForall = prodCert.idCertificar;
              throw BreakException;
            }
          });
        } catch (e) {
          if (e !== BreakException) throw e;
        };
        break;
      }
      switch(completo){
        // case 1: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.CURRENT'; break;
        default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED';
      }
      this.productosAsignados.push(
        {
          category: 'CGO',
          length  : 30,
          title   : 'WIZARD.'+producto+'.TITULO',
          date : fecha,
          url : url,
          productoID : idProducto,
          start : 'WIZARD.LANDING.ENTRAR',
          idProducto:elem.idProducto,
          completo,
          tagStatus,
          tableauVersion,
          activo,
          idProductoForall,
          tokenEncuesta:tokenEncuesta,
          idSurveyConfig:idSurveyConfiguration,
          fechaCierre:fechaCierreEncuesta,
        }
      );

    });
    datos.forEach( (elem) => {
      if (elem.idProducto==1||elem.idProducto==20||elem.idProducto==40) {
      console.log(elem);
      let fecha:number;
      let idProducto:string;
      let completo: number;
      let tagStatus: string;
      let tableauVersion: string;
      let activo: boolean;
      let idProductoForall: string;
      let tokenEncuesta: string;
      let idSurveyConfiguration: string;
      let fechaCierreEncuesta: string;
      switch(producto){
        case 'CERTIFICAR': case 'IZZI':
        if (elem.idProducto==1 || elem.idProducto==20 || elem.idProducto==40) {
        fecha = elem.fechaCertificar; idProducto = elem.idCertificar;
        completo = 2; tableauVersion = elem.tokenConfig; activo = elem.activo;
        tokenEncuesta=elem.tokenConfig;
        idSurveyConfiguration=elem.idSurvey;
        if (elem.fechaCierre) {
          fechaCierreEncuesta=elem.fechaCierre.fechaCierre;
        }else{
          fechaCierreEncuesta="";
        }
}
        var BreakException = {};
        try {
          datos.forEach((prodCert:any) => {
            if(prodCert.fechaCertificar == elem.fechaCertificar){
              idProductoForall = prodCert.idCertificar;
              throw BreakException;
            }
          });
        } catch (e) {
          if (e !== BreakException) throw e;
        };
        break;
      }
      switch(completo){
        // case 1: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.CURRENT'; break;
        default: tagStatus = 'WIZARD.LANDING.PRODUCTO.'+producto+'.RESULTS.FINISHED';
      }

      this.productosAsignadosCertificar.push(
        {
          category: 'CGO',
          length  : 30,
          title   : 'WIZARD.'+producto+'.TITULO',
          date : fecha,
          url : url,
          productoID : idProducto,
          start : 'WIZARD.LANDING.ENTRAR',
          completo,
          tagStatus,
          idProducto:elem.idProducto,
          // tableauVersion: this.tableauVersion,
          activo,
          idProductoForall,
          tokenEncuesta:tokenEncuesta,
          idSurveyConfig:idSurveyConfiguration,
          fechaCierre:fechaCierreEncuesta,
        }
      );
    }
    });
    console.log("asignados solamente certificar con resultados.:::::::::::::::::: ",this.productosAsignadosCertificar);
    if(this.productosAsignadosCertificar.length > 0){
      // this.productosAsignados=this.productosAsignadosCertificar;
      this.productosAsignados.push(...this.productosAsignadosCertificar);
      if(this.productosResultados.length > 0 && this.productosAsignados.length < this.productosResultados.length){
        console.log("Tiene resultados extras");
        for(let inicio = 0; inicio < this.productosResultados.length; inicio++){
          this.AuxproductosAsignadosCertificar.push(
            {
              category: 'CGO',
              length  : 30,
              title   : 'WIZARD.'+producto+'.TITULO',
              date : this.productosResultados[inicio].fecha,
              url : url,
              productoID :this.productosResultados[inicio]._id,
              start : 'WIZARD.LANDING.ENTRAR',
              completo: 2,
              tagStatus: "WIZARD.LANDING.PRODUCTO.CERTIFICAR.RESULTS.FINISHED",
              // tableauVersion: this.tableauVersion,
              activo:this.productosResultados[inicio].activo,
              idProductoForall: this.productosResultados[inicio]._id
            }
          );

        }// FIN for
        //console.log(this.AuxproductosAsignadosCertificar);
        this.productosAsignados=this.AuxproductosAsignadosCertificar;
      }
    }

  }
  this.cargando = false;
  this.cargandoNuevos = false;
  this.productosAsignados.sort( (a,b) => { if(a.date < b.date){ return 1; } else{ return -1; } });
  console.log("asignados.",this.productosAsignados);

}

resultFuncionando(){
  console.log('la mando a llamar ');

  this.servTableau.getFlagSuccesGo().subscribe((respuesta:any) => {
    console.log('respuesta',respuesta);
    this.gralResultActivo = respuesta.flagStatus;

  })
}

// navigateTo(ruta,productoID,tableauVersion,producto?,idProducto?){
// console.log('esta funcion entro',idProducto);
// localStorage.setItem('tipoMedir',idProducto);
// if (this.gralResultActivo) {
//   if (producto){
//     if(producto.idProductoForall){
//       localStorage.setItem('productoID', producto.idProductoForall);
//     }else{
//       localStorage.setItem('productoID', productoID);
//     }
//   }else{
//     localStorage.setItem('productoID', productoID);
//   }
//   this.router.navigate([ruta], { state: {tableauVersion} });
// }else{
//   Swal.fire({
//     title: 'Por el momento los resultados no están disponibles, porfavor intentar más tarde ',
//     icon: 'warning',
//     confirmButtonText: 'ok',
//     confirmButtonColor: '#e40601'
//   });
// }
// }
navigateTo(ruta:any,productoID:any,tableauVersion:any,producto?:any,idProducto?:any){
console.log('esta funcion entro',idProducto);
console.log('ruta funcion entro',ruta);
console.log('productos entro',producto);
localStorage.setItem('tipoMedir',idProducto);
localStorage.setItem('fechaProductorResult',producto.date);
if (this.gralResultActivo) {
  if (producto){
    if(producto.idProductoForall){
      localStorage.setItem('productoID', producto.idProductoForall);
    }else{
      localStorage.setItem('productoID', productoID);
    }
  }else{
    localStorage.setItem('productoID', productoID);
  }
  this.router.navigate([ruta], { state: {tableauVersion} });
}else{
  Swal.fire({
    title: this.translateSrv.instant('MODALES.MENSAJES.NO_RESU_ACTI'),
    icon: 'warning',
    showCancelButton: false,
    confirmButtonText:  this.translateSrv.instant('MODALES.MENSAJES.OK'),
  }).then((result) => {
    if (result.value) {
      console.log('goBack');
      this.tipoSeleccionado = null;
      this.tipoSeleccionadoNuevoProducto = null;
      this.productosAsignados = [];
      this.productosAsignadosCertificar = [];
      this.AuxproductosAsignadosCertificar=[];
      this.cargando = true;
      this.cargandoNuevos = true;
      this.ForAllViejas=true;
      this.menuProductosNuevosAmco=false;

    }
  });

}
}

navigateToForAllNuevo(ruta,productoID,tableauVersion,producto){
console.log('productoID',productoID);
console.log('producto',producto);
localStorage.setItem('tipoResultForall', producto.idProducto);
localStorage.setItem('tokenEncuestaV3', producto.tokenEncuesta);
localStorage.setItem('idSurveyConfiguration4All', producto.idSurveyConfig);
localStorage.setItem('productoID', productoID);
this.router.navigate([ruta], { state: {tableauVersion} });
}

mensajeSwal(mensaje:string, tipoMsg:number){
  let texto = '';
  this.translateSrv.get(mensaje).subscribe((res: string) => { texto = res; });
  let tipo: any;
  let rspSi = 'MODALES.ACCIONES.aceptar';
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
  switch(tipoMsg){
    case 1: tipo = 'success'; break;
    case 2: tipo = 'warning'; break;
    case 3: tipo = 'error'; break;
  }
  Swal.fire({
    title: texto,
    icon: tipo,
    confirmButtonText: rspSi,
    confirmButtonColor: '#e40601'
  });
}

mensajeResultModal(){
this.servTableau.getMensajeResultModal().subscribe((respuesta:any) => {
  let rspSi = 'MODALES.ACCIONES.aceptar';
  this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    console.log("getMensajeResultModal:",respuesta);
    console.log('this.flagResults',this.flagResults);

    if (respuesta.success==true) {
      this.flagResults=respuesta.flagResults;
      if (this.flagResults[0].flag==true) {
        console.log('idioma nativos ',this.translateSrv.currentLang);
        this.flagResults[0].modal.forEach(textModal => {
        if (textModal.clave==this.translateSrv.currentLang) {
          let text=textModal.text
          Swal.fire({
            icon: 'warning',
            title: text,
            confirmButtonText: rspSi,
          });
        }

        });
      }
    }

  });
}
copyMessage(producto){
  this.openSuccessSnackBar(this.translateSrv.instant('WIZARD.LANDING_REQUERIMIENTOSV3.COPYA_MESSAGE'),'OK');
  console.log('producto',producto);
let companyId= localStorage.getItem('companyID');
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  // selBox.value=val;
  selBox.value=DATOS_API.url4allExterno+producto.idProducto+'/'+producto.productoID+'/'+companyId+'/'+producto.idSurveyConfig;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
}
openSuccessSnackBar(message: string, action: string) {
   this.snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['background-success']
   });
}

}
